import { LightningElement,api } from "lwc";
import { ButtonItem } from "./types";
export type { ButtonItem };

export default class WesButton extends LightningElement {

    @api buttonitem: ButtonItem = null!;
    @api disabled: boolean | null = null;
    @api label: string | null = null;
    
    private get showWesButton() {
        return this.buttonitem !== null;
    }
   
    handleButtonClick(){  
        if(!this.disabled) {
            this.dispatchEventMethod("buttonclick",{ buttonId: this.buttonitem.id, name: this.buttonitem.buttonLabel.value });
        }
    }

    dispatchEventMethod(eventName: string, eventDetail: { buttonId: string, name: string }){
        this.dispatchEvent(
            new CustomEvent(eventName, {
                detail: eventDetail,
            })
        );
    }
}
